import { TestLocators } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';
import { useIsDarkMode } from 'hooks/useIsDarkMode';
import React, { useCallback, useState } from 'react';

import { colors } from 'styles/theme/colors';

import { ProfileMenu } from './ProfileMenu';
import { ReactComponent as ProfileDarkIcon } from './ProfileMenu/profile-dark.svg';
import { ReactComponent as ProfileLightIcon } from './ProfileMenu/profile-light.svg';

export const Profile = () => {
  const isDarkMode = useIsDarkMode();
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState<HTMLDivElement | null>(null);
  const ProfileIcon = isDarkMode ? ProfileDarkIcon : ProfileLightIcon;
  const handleClickProfileMenu = ({ currentTarget }: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setProfileMenuAnchorEl(currentTarget);
  };

  const handleCloseProfileMenu = useCallback(() => {
    setProfileMenuAnchorEl(null);
  }, []);

  return (
    <>
      <MUI.Box
        onClick={handleClickProfileMenu}
        data-testid={TestLocators.UserProfile}
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          cursor: 'pointer',
          paddingLeft: '5px',
          marginLeft: '5px',
          marginRight: '5px',
          color: isDarkMode ? colors.baseGrey10 : colors.grey42,
          ...(isDarkMode ? {} : { '&:hover': { color: colors.primary } }),
        }}
      >
        <MUI.Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'initial',
            margin: 0,
            justifyContent: 'center',
            height: '36px',
            width: '36px',
            backgroundColor: isDarkMode ? colors.baseGrey57 : colors.primaryWhite,
          }}
        >
          <ProfileIcon
            style={{
              width: 32,
              height: 32,
              padding: 3,
              border: `1px ${colors.grey62} solid`,
              borderRadius: '5px',
            }}
          />
        </MUI.Box>
      </MUI.Box>
      <ProfileMenu anchorEl={profileMenuAnchorEl} onClose={handleCloseProfileMenu} />
    </>
  );
};
